import React, { useState, useEffect } from "react";
import dashboardclasses from "../dashboard.module.css";
import { IoClose } from "react-icons/io5";
import { FileUploader } from "react-drag-drop-files";
import { BsCloudUpload } from "react-icons/bs";
import { useForm } from "react-hook-form";
import { Services } from "../../Services";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ToastError } from "../../Components/utils/ToastMessage";
import { AiOutlineClose } from "react-icons/ai";
import swal from "sweetalert";
import { v4 as uuidv4 } from "uuid";
import {
    validateNegativeValues,
    validateEmptySpaces,
    validateDate,
    validateEndDate,
} from "../../Components/utils/validations";
function AddCategory(props) {
    const Navigate = useNavigate();
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        watch,
        formState: { errors },
    } = useForm();
    const [base64, setbase64] = useState("");
    const [soceity, setSoceity] = useState([]);
    const [categories, setCategories] = useState([]);
    const [Subcategories, setSubcategories] = useState([]);
    const watchFormData = watch();

    useEffect(() => {
        Fetch_Drop_Downs();
        const close = (e) => {
            if (e.key == "Escape") {
                console.log("close");
                props.setmodal(false);
                props.setEditable(false);
            }
        };
        window.addEventListener("keydown", close);
        return () => window.removeEventListener("keydown", close);
    }, []);

    async function Fetch_Drop_Downs() {
        try {
            const [response1, response2] = await Promise.all([
                Services.getSocieties("GET", null, token),
                Services.Get_service_dropdown("GET", null, token),
            ]);
            if (response1.Status === 1) {
                setSoceity(response1.societies);
            }

            if (response2.Status === 1) {
                setCategories(response2.categories);
            }
            if (
                props.editable &&
                response2.Status === 1 &&
                response1.Status === 1
            ) {
                const { image, ...editData } = props.editable;

                if (props.editable.couponfor == "Service") {
                    await Get_SubCategory_DropDown(props.editable.categoryname);
                }
                reset({ ...editData });
                setbase64(
                    `https://www.heyman.in/static/img/coupons/${props.editable.image}`
                );
            }
        } catch (err) {
            console.log(err);
            alert("something went wrong");
        }
    }

    async function Get_SubCategory_DropDown(name) {
        try {
            const response = await Services.Get_SubCategory_Dropdown(
                "POST",
                JSON.stringify({ categoryname: name }),
                token
            );
            if (response.Status === 1) {
                setSubcategories(response.categories);
            }
        } catch (err) {
            alert("something went wrong");
            console.log(err);
        }
    }
    const CancelHandler = (e) => {
        e.stopPropagation();
        props.setmodal(false);
        props.setEditable(false);
    };

    const openhandler = (e) => {
        e.stopPropagation();
    };
    // const handleChange = (file) => {
    //     if (file.type === "image/png" || file.type === "image/jpeg") {
    //         setValue("image", file);
    //         let reader = new FileReader();
    //         reader.readAsDataURL(file);
    //         reader.onload = function () {
    //             setbase64(reader.result);
    //         };
    //         reader.onerror = function (error) {
    //             console.log("Error: ", error);
    //         };
    //     } else {
    //         alert("please upload image in PNG and JPEG format ");
    //     }
    // };

    const onSubmit = (data) => {
        let formaata = new FormData();
        let form_Data = { ...data };

        if (watchFormData.condition != 3) {
            delete form_Data.societyId;
        }

        if (watchFormData.condition != 5) {
            delete form_Data.categoryname;
            delete form_Data.subcategoryname;
        }
        if (
            form_Data?.categoryname == "NA" ||
            form_Data?.categoryname?.length == 0
        ) {
            delete form_Data.categoryname;
        }
        if (
            form_Data?.subcategoryname == "NA" ||
            form_Data?.subcategoryname?.length == 0
        ) {
            delete form_Data.subcategoryname;
        }
        if (
            form_Data?.societyName == "NA" ||
            form_Data?.societyName?.length == 0
        ) {
            delete form_Data.societyName;
        }

        Object.keys(form_Data).forEach((key) => {
            formaata.set(key, data[key]);
        });
        if (!props.editable) {
            fetch(`${process.env.REACT_APP_BASE_URL_PYTHON}/${Services.addCoupon}`, {
                method: "POST",
                body: formaata,
                Authorization: `token ${sessionStorage.getItem("token")}`,
            })
                .then((response) => response.json())
                .then((res) => {
                    console.log(res);
                    props.tableload(false);
                    if (res.Status === 1) {
                        Navigate(`/Coupons?page=1`);
                        props.setpageCount(1);
                        props.setmodal(false);
                        props.tableload(true);
                        props.getCategories();
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((error) => {
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(error);
                });
        } else if (props.editable) {
            formaata.append("couponId", props.editable.couponId);
            fetch(
                `${process.env.REACT_APP_BASE_URL_PYTHON}/${Services.updateCoupon}`,
                {
                    method: "POST",
                    body: formaata,
                    Authorization: `token ${sessionStorage.getItem("token")}`,
                }
            )
                .then((response) => response.json())
                .then((res) => {
                    console.log(res);
                    props.tableload(false);
                    if (res.Status === 1) {
                        Navigate(`/Coupons?page=1`);
                        props.setpageCount(1);
                        props.setmodal(false);
                        props.getCategories();
                        props.setEditable(false);
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((error) => {
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(error);
                });
        }
    };

    return (
        <div className={dashboardclasses.modal} onClick={CancelHandler}>
            <div
                className={dashboardclasses["modal-content"]}
                onClick={openhandler}>
                <div className={dashboardclasses["modal-content-header"]}>
                    <div>
                        <h3>
                            {props.editable ? "Update Coupon" : "Add Coupon"}
                        </h3>
                        <p>
                            {props.editable ? "Update Coupon" : "Add Coupon"}{" "}
                            and necessary information from here
                        </p>
                    </div>
                    <button
                        className={dashboardclasses["close-btn"]}
                        onClick={CancelHandler}>
                        <IoClose size={22} color={"red"} />
                    </button>
                </div>
                <form
                    className={dashboardclasses["add-items"]}
                    onSubmit={handleSubmit(onSubmit)}>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Name</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="text"
                                {...register("name", {
                                    required: "Coupon name is required",
                                    validate: validateEmptySpaces,
                                })}
                            />
                            {errors?.name && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.name?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    {/* <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="category">Coupon Image</label>

                        <FileUploader
                            classes={dashboardclasses["upload-image"]}
                            multiple={false}
                            handleChange={handleChange}
                            name="file"
                            children={fileuploadDesign}
                            // types={fileTypes}
                        />
                    </div> */}
                    <div className={dashboardclasses["uploaded-img"]}>
                        <img src={base64} alt="" width={"120px"} />
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Coupon For</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("couponfor", {
                                    required: "couponfor is required",
                                })}
                                defaultValue={""}>
                                <option value="" disabled>
                                    Select Coupon for
                                </option>
                                <option value="Omni">Omni</option>
                                <option value="Service">Service</option>
                            </select>
                            {errors?.couponfor && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.couponfor?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Condtion</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("condition", {
                                    required: "Condition is required",
                                })}>
                                <option value="1">First Order</option>
                                <option value="4">Second Order</option>
                                <option value="2">All Orders</option>
                                <option value="3">Society</option>
                                {watchFormData.couponfor != "Omni" && (
                                    <option value="5">Category</option>
                                )}
                            </select>
                            {errors?.condition && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.condition?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Coupon Type</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("couponType", {
                                    required: "Coupon Type is required",
                                })}>
                                <option value="discount">Discount</option>
                                <option value="amount">Flat</option>
                            </select>
                            {errors?.couponType && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.couponType?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    {watchFormData.condition == 5 && (
                        <>
                            <div
                                className={
                                    dashboardclasses["item-image-upload"]
                                }>
                                <label htmlFor="categoryname">
                                    Category Name
                                </label>
                                <div className={dashboardclasses["select"]}>
                                    <select
                                        defaultValue={"NA"}
                                        {...register("categoryname", {
                                            required:
                                                "Category Name is required",
                                            onChange: (e) => {
                                                setValue(
                                                    "subcategoryname",
                                                    "NA"
                                                );
                                                Get_SubCategory_DropDown(
                                                    e.target.value
                                                );
                                            },
                                        })}>
                                        <option value="NA" disabled>
                                            Select Category
                                        </option>
                                        {categories.map((item) => (
                                            <option
                                                value={`${item.categoryname}`}>
                                                {item.categoryname}
                                            </option>
                                        ))}
                                    </select>
                                    {errors?.categoryname && (
                                        <p
                                            className={
                                                dashboardclasses["error"]
                                            }>
                                            {errors?.categoryname?.message}
                                        </p>
                                    )}
                                </div>
                            </div>

                            <div
                                className={
                                    dashboardclasses["item-image-upload"]
                                }>
                                <label htmlFor="categoryname">
                                    Subcategory Name
                                </label>
                                <div className={dashboardclasses["select"]}>
                                    <select
                                        {...register("subcategoryname", {
                                            required: false,
                                        })}
                                        defaultValue={"NA"}>
                                        <option value="NA" disabled>
                                            Select Subcategory
                                        </option>
                                        {Subcategories.map((item) => (
                                            <option
                                                value={item.subcategoryname}>
                                                {item.subcategoryname}
                                            </option>
                                        ))}
                                    </select>
                                    {errors?.subcategoryname && (
                                        <p
                                            className={
                                                dashboardclasses["error"]
                                            }>
                                            {errors?.subcategoryname?.message}
                                        </p>
                                    )}
                                </div>
                            </div>
                        </>
                    )}
                    {watchFormData.condition == 3 && (
                        <div className={dashboardclasses["item-image-upload"]}>
                            <label htmlFor="categoryname">Society</label>
                            <div className={dashboardclasses["select"]}>
                                <select
                                    {...register("societyId", {
                                        required:
                                            watchFormData.condition == 3
                                                ? "Society is required"
                                                : false,
                                    })}
                                    defaultValue={"NA"}>
                                    <option value="NA" disabled>
                                        Select Society
                                    </option>
                                    {soceity.map((item) => (
                                        <option value={item.societyId}>
                                            {item.societyName}
                                        </option>
                                    ))}
                                </select>
                                {errors?.societyId && (
                                    <p className={dashboardclasses["error"]}>
                                        {errors?.societyId?.message}
                                    </p>
                                )}
                            </div>
                        </div>
                    )}
                    {/* <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Coupon Type</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("couponType", {
                                    required: "Coupon Type is required",
                                })}>
                                <option value="discount">Discount</option>
                                <option value="amount">Flat</option>
                            </select>
                            {errors?.couponType && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.couponType?.message}
                                </p>
                            )}
                        </div>
                    </div> */}
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">Coupon Value</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                {...register("value", {
                                    required: "Value is required",
                                    validate: validateNegativeValues,
                                })}
                            />

                            {errors?.value && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.value?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">Min Order Value</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                {...register("minOrderValue", {
                                    required: "Min Order Value is required",
                                    validate: validateNegativeValues,
                                })}
                            />

                            {errors?.minOrderValue && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.minOrderValue?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">Max Discount</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                {...register("maxDiscount", {
                                    required: "Max Discount is required",
                                    validate: validateNegativeValues,
                                })}
                            />

                            {errors?.maxDiscount && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.maxDiscount?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">Max Order Quantity</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                {...register("maxorderqty", {
                                    required: "Max Order Quantity is required",
                                    validate: validateNegativeValues,
                                })}
                            />

                            {errors?.maxorderqty && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.maxorderqty?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">Start Date</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="date"
                                placeholder="dd-mm-yyyy"
                                {...register("startDate", {
                                    required: "Start Date is required",
                                })}
                            />

                            {errors?.startDate && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.startDate?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">End Date</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="date"
                                placeholder="dd-mm-yyyy"
                                {...register("endDate", {
                                    required: "End Date is required",
                                })}
                            />

                            {errors?.endDate && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.endDate?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="">Description</label>
                        <div className={dashboardclasses["select"]}>
                            <textarea
                                {...register("description", {
                                    required: "Description is required",
                                    validate: validateEmptySpaces,
                                })}
                                rows="4"></textarea>
                            {errors?.description && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.description?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="status">Status</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("status", {
                                    required: "status is required",
                                })}>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                            {errors?.status && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.status?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["add-btn"]}>
                        <button type="button" onClick={CancelHandler}>
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={dashboardclasses["add-category-btn"]}>
                            {props.editable ? "update" : "Add Coupon"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
